<template>
  <div class="event-card" @click="$emit('select', event)">
    <h3>{{ event.title }}</h3>
    <hr />
    <div class="loc-date">
      <div class="venue"><span>Venue:</span> {{ event.venue }}</div>
      <div class="location"><span>Location:</span> {{ event.location }}</div>
      <div class="date"><span>Date</span> {{ event.date }}</div>
    </div>
    <p class="description">{{ truncatedDescription }}</p>
  </div>
</template>

<script>
export default {
  name: 'EventCard',
  props: {
    event: Object,
  },
  computed: {
    truncatedDescription() {
      return this.event.description.length > 100
        ? this.event.description.slice(0, 90) + '...'
        : this.event.description;
    },
  },
};
</script>

<style scoped>
.event-card {
  background: #1a1a1a;
  border-radius: 10px;
  padding: 1rem;
  cursor: pointer;
  transition: transform 0.2s ease;
  color: #eee;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.6);
  width: 250px;
}

.event-card:hover {
  transform: scale(1.02);
  box-shadow: 0 0 10px #2c3e50;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

h3 {
  font-size: 1.3rem;
  margin: 0 0 0.8rem 0;
  height: 3rem;
  color: #909078;
}

.loc-date {
  margin: auto;
  width: fit-content;
}

.loc-date span {
  color: #67667e;
}

.venue,
.location,
.date {
  color: #bbb;
  margin-bottom: 0.2rem;
  text-align: left;
  width: fit-content;
  font-size: 1.1rem;
  font-weight: 500;
}

.date {
  margin-bottom: 0.5rem;
}

.description {
  color: #ccc;
  font-size: 1rem;
  width: 200px;
  white-space: normal;
  word-wrap: break-word;
  font-style: italic;
  text-align: center;
  margin: auto;
  min-height: 5rem;
}
</style>
